import { render, staticRenderFns } from "./UserInfoSection.htm?vue&type=template&id=1e000454&scoped=true&"
import script from "./UserInfoSection.ts?vue&type=script&lang=js&"
export * from "./UserInfoSection.ts?vue&type=script&lang=js&"
import style0 from "./UserInfoSection.scss?vue&type=style&index=0&id=1e000454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e000454",
  null
  
)

export default component.exports